/*
  Exposes:
    - window.initInfiniteScroll()  -> initializes observer
    - window.destroyInfiniteScroll() -> disconnects existing observer
*/
(function () {
  let observer = null;

  function destroyInfiniteScroll() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function initInfiniteScroll() {
    // clean any previous instance
    destroyInfiniteScroll();

    const viewMoreElement = document.querySelector(".js-btn-load-more");
    if (!viewMoreElement) return;

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // click triggers your existing load more flow
          viewMoreElement.click();
        }
      });
    });

    observer.observe(viewMoreElement);
  }

  // expose on window so other scripts (facets) can re-init after AJAX replace
  window.initInfiniteScroll = initInfiniteScroll;
  window.destroyInfiniteScroll = destroyInfiniteScroll;

  // initialize once on first load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initInfiniteScroll);
  } else {
    initInfiniteScroll();
  }
})();
